<template>
  <v-toolbar color="teal darken-4" dark app class="elevation-0" :clipped-left="true" fixed height="60">
    <v-toolbar-title class="ml-0 pl-3">
      <v-toolbar-side-icon @click.stop="toggleSidebar" class="sidebarToggler" v-if="isAdministrator"></v-toolbar-side-icon>
      <span v-show="$vuetify.breakpoint.smAndUp" @click="reloadPage" style="cursor: pointer;">Tree Logistics System</span>
      <span v-if="environment" style="color: red; margin-left: 50px;">{{ environment }}</span>
      <span v-if="(isAdministrator || isImpersonating) && (hasArchivedProduction || hasActiveProduction)" class="hidden-xs-only" style="margin-left: 75px;">{{ 'Season&nbsp;&nbsp;' + (hasArchivedProduction ? archivedProductionName : activeProductionName) }}</span>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <span v-show="displayPageTitle" class="pageTitle v-toolbar__title">{{ pageTitle }}</span>
    <v-spacer></v-spacer>
    <div v-if="newVersionAvailable" style="padding-right: 30px;" class="clickable" @click="showNewVersionDialog = true">
      <v-icon style="font-size: 20px;" class="blink_faster">autorenew</v-icon>
    </div>
    <div v-if="!isAdministrator && hasContractorRole && showContractorStatusWarning" style="padding-right: 20px;" class="clickable" @click="contractorStatusWarning = true">
      <v-icon :style="contractorStatusWarningStyle" class="blink">error</v-icon>
    </div>
    <v-btn @click="endArchivedProduction" v-if="hasArchivedProduction" :style="'background-color: #FAFDFC !important; border-radius: 6px; border: 1px solid #004d40 !important; color: #004d40 !important; box-shadow: none; margin-right: ' + (isImpersonating ? 10 : 40) + 'px !important;'">{{ 'Leave season ' + archivedProductionName }}</v-btn>
    <v-btn @click="endImpersonation" v-if="isImpersonating" class="btnEndImpersonation" style="background-color: #FAFDFC !important; border-radius: 6px; border: 1px solid #004d40 !important; color: #004d40 !important; box-shadow: none;">End impersonation</v-btn>
    <span class="hidden-xs-only">{{ fullName }}</span>
    <v-icon class="sessionStatus" @click="sessionStatusDialog = true">{{ sessionStatusIcon }}</v-icon>
    <v-icon class="networkStatus" v-if="!isAdministrator" @click="wifiStatusDialog = true">{{ networkStatusIcon }}</v-icon>
    <v-icon class="signout" title="Logout" @click="logout">power_settings_new</v-icon>
    <v-snackbar v-model="snackbar" :timeout='5000' top right>{{ snackbarMessage }}</v-snackbar>
    <v-dialog v-model="sessionStatusDialog" width="30vw" class="sessionStatusDialog">
      <div class="sessionStatusDialogContent" v-if="isConnected">
        <v-icon class="dialogIcon">done</v-icon>You are connected to the server
      </div>
      <div class="sessionStatusDialogContent" v-if="!isConnected && isOnline">
        <v-icon class="dialogErrorIcon">notification_important</v-icon>You have lost connection to the server.<br/>If the error continues, please logout and login again.
      </div>
      <div class="sessionStatusDialogContent" v-if="!isConnected && !isOnline">
        <v-icon class="dialogErrorIcon">notification_important</v-icon>You are not connected to the server due to missing internet connection at the moment.
      </div>
    </v-dialog>
    <v-dialog v-model="wifiStatusDialog" width="30vw" class="wifiStatusDialog">
      <div class="sessionStatusDialogContent" v-if="isOnline">
        <v-icon class="dialogIcon">done</v-icon>You are connected to the internet
      </div>
      <div class="sessionStatusDialogContent" v-if="!isOnline">
        <v-icon class="dialogErrorIcon">notification_important</v-icon>You are not connected to the internet at the moment
      </div>
    </v-dialog>
    <v-dialog v-model="contractorStatusWarning" width="40vw" class="contractorStatusWarningDialog">
      <div class="contractorStatusWarningDialogContent">
        <v-icon class="dialogErrorIcon">notification_important</v-icon>You have {{ numberOfCommandsInQueue }} update{{ numberOfCommandsInQueue !== 1 ? 's' : '' }} within the last {{ ageHoursOfOldestCommandInQueue }} hour{{ ageHoursOfOldestCommandInQueue !== 1 ? 's' : ''}},
        which {{ numberOfCommandsInQueue !== 1 ? 'have' : 'has' }} not yet been received.<br/><br/>Please make sure to establish network connection as soon as possible until this warning disappears.
      </div>
    </v-dialog>
    <v-dialog v-model="showNewVersionDialog" width="60vw" class="newVersionDialog">
      <div class="newVersionDialogContent">
        A new version {{ newVersion }} is available.
        <br/>
        Please make sure to have a stable internet connection before upgrading.
        <br/>
        <div style="text-align: center; padding-top: 2vh;">
          <v-btn class="newVersionButton" @click="upgradeApplication">Upgrade to version {{ newVersion }}</v-btn>
        </div>
      </div>
    </v-dialog>
  </v-toolbar>
</template>

<script>
import DateUtil from '@/assets/javascript/dateutil'
import axios from 'axios'

export default {
  name: 'Header',
  data () {
    return {
      displayPageTitle: false,
      snackbar: false,
      snackbarMessage: '',
      sessionStatusDialog: false,
      wifiStatusDialog: false,
      contractorStatusWarning: false,
      showNewVersionDialog: false,
      upgradeButtonDisabled: false
    }
  },
  methods: {
    toggleSidebar: function () {
      this.$store.dispatch('sidebar/toggle')
    },
    showSnackbar: function (message) {
      this.snackbarMessage = message
      this.snackbar = true
    },
    logout () {
      this.$store.dispatch('session/logout')
      this.$store.dispatch('page/setSidebarItem', {})
      this.$router.push({name: 'Login'})
    },
    reloadPage () {
      window.location.reload()
    },
    upgradeApplication () {
      this.showNewVersionDialog = false
      this.$store.dispatch('status/upgradeApplication', this.newVersion)
    },
    endImpersonation () {
      this.$store.dispatch('session/endImpersonation', {})
        .then((response) => {
          this.$store.dispatch('page/setSidebarItem', { key: 'users' })
          this.$router.push({name: 'Users'})
        })
        .catch((error) => {
          console.log('Error: \'' + error.message + '\'')
        })
    },
    endArchivedProduction () {
      axios.post('/backend/rest/production/select/active')
        .then(response => {
          this.$store.dispatch('session/stopArchivedProduction')
          this.$store.dispatch('page/setSidebarItem', { key: 'dashboard' })
          this.$router.push({name: 'Dashboard'})
        })
    }
  },
  computed: {
    fullName: function () {
      return this.$store.state.session.fullName
    },
    pageTitle: function () {
      return this.$store.state.page.title
    },
    isAdministrator: function () {
      return this.$store.getters['session/hasAdministratorRole']
    },
    isConnected: function () {
      return this.$store.getters['session/isConnected'] && this.isOnline
    },
    isImpersonating: function () {
      return this.$store.getters['session/isImpersonating']
    },
    hasArchivedProduction: function () {
      return this.$store.getters['session/hasArchivedProduction']
    },
    archivedProductionName: function () {
      return this.hasArchivedProduction ? this.$store.getters['session/getArchivedProduction'].name : ''
    },
    hasActiveProduction: function () {
      return this.$store.getters['session/hasActiveProduction']
    },
    activeProductionName: function () {
      return this.hasActiveProduction ? this.$store.getters['session/getActiveProduction'].name : ''
    },
    sessionStatusIcon: function () {
      return this.isConnected ? 'cloud_done' : 'cloud_off'
    },
    networkStatusIcon: function () {
      return this.isOnline ? 'wifi' : 'wifi_off'
    },
    hasContractorRole: function () {
      return this.$store.getters['session/hasRole']('CONTRACTOR')
    },
    numberOfCommandsInQueue: function () {
      return this.$store.getters['status/getNumberOfCommandsInQueue']
    },
    ageHoursOfOldestCommandInQueue: function () {
      let timestamp = this.$store.getters['status/getOldestCommandTimestamp']
      return timestamp != null ? DateUtil.ageInHours(timestamp) : 0
    },
    showContractorStatusWarning: function () {
      if (this.numberOfCommandsInQueue > 0) {
        let ageHours = this.ageHoursOfOldestCommandInQueue
        // console.log('Age in hours of oldest command: ' + ageHours)
        return ageHours > 0
      }
      return false
    },
    newVersionAvailable: function () {
      return this.$store.getters['status/getApplicationVersion'] !== '' && this.$store.getters['status/getApplicationVersionNew'] !== '' && this.$store.getters['status/getApplicationVersion'] !== this.$store.getters['status/getApplicationVersionNew']
    },
    newVersion: function () {
      return this.$store.getters['status/getApplicationVersionNew']
    },
    contractorStatusWarningStyle: function () {
      let color = this.ageHoursOfOldestCommandInQueue > 3 || this.numberOfCommandsInQueue > 10 ? '#FF6666' : '#FFBB66'
      return 'font-size: 36px; color: ' + color + ';'
    },
    contractorStatus: function () {
      let numberInQueue = this.$store.getters['status/getNumberOfCommandsInQueue']
      if (numberInQueue > 0) {
        let timestamp = this.$store.getters['status/getOldestCommandTimestamp']
        return numberInQueue + ' since ' + timestamp.getHours() + ':' + timestamp.getMinutes()
      }
      return ''
    },
    environment: function () {
      let runMode = this.$store.getters['status/getRunMode']
      return runMode === 'PRODUCTION' ? '' : runMode === 'TEST' ? 'Test' : runMode === 'QA' ? 'QA' : runMode === 'DEVELOPMENT' ? 'Development' : ''
    }
  }
}
</script>

<style scoped>
  .pageTitle {
    padding-left: 60px;
  }
  .sessionStatus,
  .networkStatus {
    font-size: 18px;
    padding-left: 15px;
  }
  .signout {
    font-size: 18px;
    padding-left: 15px;
    cursor: pointer;
  }
  .blink {
    animation: blink 2s steps(8, start) infinite;
    -webkit-animation: blink 2s steps(8, start) infinite;
  }
  .blink_faster {
    animation: blink 1.7s steps(2, start) infinite;
    -webkit-animation: blink 1.7s steps(2, start) infinite;
  }
  @keyframes blink {
    to {
      visibility: hidden;
    }
  }
  @-webkit-keyframes blink {
    to {
      visibility: hidden;
    }
  }
  .clickable {
    cursor: pointer;
  }
  .sessionStatusDialogContent {
    background-color: white !important;
    padding: 4vh 2vw;
    border-radius: 10px;
    font-size: 16px;
  }
  .wifiStatusDialogContent {
    background-color: white !important;
    padding: 4vh 2vw;
    border-radius: 10px;
    font-size: 16px;
  }
  .contractorStatusWarningDialogContent {
    background-color: white !important;
    padding: 4vh 2vw;
    border-radius: 10px;
    font-size: 16px;
  }
  .newVersionDialogContent {
    background-color: white !important;
    padding: 4vh 2vw;
    border-radius: 10px;
    font-size: 16px;
    text-align: center;
  }
  .dialogIcon {
    padding-right: 10px;
    color: #004d40;
  }
  .dialogErrorIcon {
    padding-right: 10px;
    color: #800000;
  }
  .newVersionButton {
    border-radius: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue